import React from 'react';
import { IconButton, Tooltip, SvgIcon } from '@mui/material';
import { useTheme } from '../contexts/ThemeContext';

const MoonIcon = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: 18 }}>
    <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      fill="none" />
  </SvgIcon>
);

const SunIcon = () => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fontSize: 18 }}>
    <circle cx="12" cy="12" r="5"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
    <line x1="12" y1="1"     x2="12" y2="3"     stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="12" y1="21"    x2="12" y2="23"    stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="4.22" y1="4.22"   x2="5.64" y2="5.64"   stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="1"  y1="12" x2="3"  y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="21" y1="12" x2="23" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="4.22" y1="19.78"  x2="5.64" y2="18.36"  stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <line x1="18.36" y1="5.64"  x2="19.78" y2="4.22"  stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
);

const ThemeToggle: React.FC = () => {
  const { mode, toggleTheme } = useTheme();

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton
        color="inherit"
        onClick={toggleTheme}
        sx={{
          backgroundColor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          color: 'text.secondary',
          '&:hover': {
            backgroundColor: 'action.hover',
          },
          boxShadow: 1,
        }}
      >
        {mode === 'dark' ? <SunIcon /> : <MoonIcon />}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;
